export const breakpoints = {
  //   values in px
  small: "640",
  medium: "768",
  large: "1024",
  extraLarge: "1280",
};
